import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  setAllCompanies,
  setAllDepartments,
  setAllEmployees,
  setAllMeetingRooms,
  setAllPositions,
} from "../../redux/actions/mainAction";

import { Input } from "antd";
const { Search } = Input;

const MainSearch = () => {
  const [searchText, setSearchText] = useState("");

  const location = useLocation();
  const pathname = location.pathname;

  const dispatch = useDispatch();

  const searchHandler = async () => {
    ///////////

    if (pathname === "/companies") {
      if (searchText) {
        let result = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/search-company/${searchText}`,
          {
            headers: {
              authorization: `bearer ${JSON.parse(
                localStorage.getItem("token")
              )} `,
            },
          }
        );
        result = await result.json();
        if (result) {
          dispatch(setAllCompanies(result));
        }
      }
    }

    ///////////

    if (pathname === "/departments") {
      if (searchText) {
        let result = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/search-department/${searchText}`,
          {
            headers: {
              authorization: `bearer ${JSON.parse(
                localStorage.getItem("token")
              )} `,
            },
          }
        );
        result = await result.json();
        if (result) {
          dispatch(setAllDepartments(result));
        }
      }
    }

    ///////////

    if (pathname === "/positions") {
      if (searchText) {
        let result = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/search-position/${searchText}`,
          {
            headers: {
              authorization: `bearer ${JSON.parse(
                localStorage.getItem("token")
              )} `,
            },
          }
        );
        result = await result.json();
        if (result) {
          dispatch(setAllPositions(result));
        }
      }
    }

    ///////////

    if (pathname === "/employees") {
      if (searchText) {
        let result = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/search-employee/${searchText}`,
          {
            headers: {
              authorization: `bearer ${JSON.parse(
                localStorage.getItem("token")
              )} `,
            },
          }
        );
        result = await result.json();
        if (result) {
          dispatch(setAllEmployees(result));
        }
      }
    }

    ///////////

    if (pathname === "/meetingrooms") {
      if (searchText) {
        let result = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/search-meetingroom/${searchText}`,
          {
            headers: {
              authorization: `bearer ${JSON.parse(
                localStorage.getItem("token")
              )} `,
            },
          }
        );
        result = await result.json();
        if (result) {
          dispatch(setAllMeetingRooms(result));
        }
      }
    }
  };

  const getCompanies = async () => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-companies`,
      {
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    dispatch(setAllCompanies(result));
  };

  const getDepartments = async () => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-departments`,
      {
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    dispatch(setAllDepartments(result));
  };

  const getPositions = async () => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-positions`,
      {
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    dispatch(setAllPositions(result));
  };

  const getEmployees = async () => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-employees/`,
      {
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    dispatch(setAllEmployees(result));
  };

  const getMeetingRooms = async () => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-meetingrooms/`,
      {
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    dispatch(setAllMeetingRooms(result));
  };

  const onChangeHandler = (text) => {
    if (text.length > 0) {
      setSearchText(text);
    } else {
      pathname === "/companies" && getCompanies();
      pathname === "/departments" && getDepartments();
      pathname === "/positions" && getPositions();
      pathname === "/employees" && getEmployees();
      pathname === "/meetingrooms" && getMeetingRooms();
    }
  };
  return (
    <div className="searcContainer">
      <Search
        style={{
          marginTop: "1.8%",
        }}
        placeholder="Axtarış et.."
        enterButton="Axtar"
        size="large"
        loading={false}
        onSearch={searchHandler}
        onChange={(e) => onChangeHandler(e.target.value)}
      />
    </div>
  );
};

export default MainSearch;
